import { render } from "./ScrollDown.vue?vue&type=template&id=01fc8ad9"
import script from "./ScrollDown.vue?vue&type=script&lang=js"
export * from "./ScrollDown.vue?vue&type=script&lang=js"

import "./ScrollDown.vue?vue&type=style&index=0&id=01fc8ad9&lang=css"
script.render = render

export default script